module.exports = __webpack_public_path__ + "static/locked.940f661f.png";